export const parseUTC = (date: string | Date): Date => {
    const dt = new Date(date);
    return new Date(dt.valueOf() + dt.getTimezoneOffset() * 60_000);
};
